<template>
  <div>
    <loading-spinner v-if="loading"> </loading-spinner>
    <pulse-queue v-else-if="!is_admin"></pulse-queue>
    <template v-else>
      <header-card
        :image="$images.PULSE_ICON"
        title="Culture Tracking Survey Management"
        sub-title="Create recurring surveys to monitor trends over time"
      >
        <template v-slot:right>
          <engagement-text
            v-if="overview.userRecords"
            title="Participation Rate"
            :engagement="overview.userRecords"
            click
            v-on:click="
              $router.push({ path: `/reporting/participation/culture` })
            "
          ></engagement-text>
        </template>
        <template v-slot:extension>
          <v-divider></v-divider>
          <v-container>
            <v-row>
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'">
                <v-btn to="/reporting/culture" color="secondary" block>
                  <v-icon class="mr-2">assessment</v-icon>
                  Reporting
                </v-btn>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'">
                <v-btn to="/features/tracking/settings" color="secondary" block>
                  <v-icon class="mr-2">settings</v-icon>
                  Admin Settings
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </header-card>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>Culture Tracking Send History</v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="pulses"
                :footer-props="{
                  'items-per-page-options': [10, 25, 50, 100]
                }"
                no-data-text="No Culture Tracking Surveys Sent"
              >
                <template v-slot:item.sentDate="{ item }">
                  <v-icon class="mr-2" color="secondary">event</v-icon>
                  <template v-if="item.sentDate">
                    {{ item.sentDate | longDate }}
                  </template>
                  <template v-else>
                    {{ item.scheduleDate | longDate }}
                  </template>
                </template>
                <template v-slot:item.isComplete="{ item }">
                  <span v-if="item.isRegistration" class="info--text">
                    Registration
                  </span>
                  <span v-else-if="!item.sentDate" class="success--text">
                    Scheduled
                  </span>
                  <span v-else-if="!item.isComplete" class="success--text">
                    Open
                  </span>
                  <span v-else class="lighttext--text">
                    Complete
                  </span>
                </template>
                <template v-slot:item.completion="{ item }">
                  <simple-engagement-text
                    :engagement="item.userRecords"
                  ></simple-engagement-text>
                </template>
                <template v-slot:item.recipientCount="{ item }">
                  <template v-if="item.userRecords">
                    {{ item.userRecords.sent }}
                  </template>
                </template>
                <template v-slot:item.actions="{ item }">
                  <send-reminder-dialog
                    v-if="!item.isComplete && item.sentDate"
                    :pulse-id="item.id"
                    :employee-count="
                      item.userRecords.sent - item.userRecords.finished
                    "
                  ></send-reminder-dialog>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SimpleEngagementText from "@/components/reporting/SimpleEngagementText";
import EngagementText from "@/components/reporting/EngagementText";
import HeaderCard from "@/components/common/HeaderCard";
import dateFilter from "@/helpers/filters/date";
import PulseQueue from "@/components/pulse/PulseQueue";
import SendReminderDialog from "@/components/pulse/SendReminderDialog";
export default {
  name: "PulseOverview",
  components: {
    SimpleEngagementText,
    EngagementText,
    HeaderCard,
    PulseQueue,
    SendReminderDialog
  },
  data: () => ({
    loading: false,
    headers: [
      { text: "Date", value: "sentDate" },
      { text: "Status", value: "isComplete" },
      { text: "Recipients", value: "recipientCount" },
      { text: "Participated", value: "completion", sortable: false },
      { text: "", value: "actions", sortable: false, align: "right" }
    ]
  }),
  computed: {
    sent_pulses() {
      return this.pulses.filter(x => x.sentDate != null);
    },
    scheduled_pulse() {
      return this.pulses.find(x => x.sentDate == null);
    },
    last_update() {
      if (this.sent_pulses.length > 0) {
        return dateFilter.longDate(this.sent_pulses[0].sentDate);
      }
      return "";
    },
    next_scheduled_date() {
      if (!this.scheduled_pulse) {
        return "";
      }
      return dateFilter.longDate(this.scheduled_pulse.scheduleDate);
    },
    ...mapGetters({
      overview: "pulse/overview",
      pulses: "pulse/pulses",
      profile: "profile/profile",
      is_admin: "profile/is_admin"
    })
  },
  created() {
    this.getPulseOverview();
  },
  methods: {
    getPulseOverview() {
      if (!this.is_admin && !this.profile.isManager) {
        return;
      }
      Promise.all([this.$store.dispatch("pulse/getOverview")])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your culture tracking surveys."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep tr:hover {
  background-color: inherit !important;
}
</style>
